(function () {
  function scrollY() {
    return window.scrollY !== undefined ? window.scrollY : window.pageYOffset;
  }

  function getUrlParts(url) {
    if (!url) return null;

    try {
      var parsed = new URL(url, window.location.origin);
      var path = parsed.pathname.replace(/\/+$/, '');
      return {
        path: path || '/',
        search: parsed.search
      };
    } catch (error) {
      return null;
    }
  }

  function getChipLabel(chip) {
    return chip.getAttribute('data-campus-label') || chip.textContent.trim();
  }

  function setOpen(root, open) {
    var toggle = root.querySelector('[data-rz-campus-toggle]');
    var panel = root.querySelector('[data-rz-campus-panel]');

    root.classList.toggle('is-open', open);
    if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (panel) panel.hidden = !open;
  }

  function setSelectedChip(root, selectedChip) {
    var label = root.querySelector('[data-rz-campus-current-label]');
    var defaultLabel = root.getAttribute('data-default-label') || 'Select your Campus';
    var chips = root.querySelectorAll('[data-rz-campus-chip]');

    chips.forEach(function (chip) {
      chip.classList.remove('is-selected');
      chip.removeAttribute('aria-current');
    });

    if (selectedChip) {
      selectedChip.classList.add('is-selected');
      selectedChip.setAttribute('aria-current', 'page');
      if (label) label.textContent = getChipLabel(selectedChip);
      return;
    }

    if (label) label.textContent = defaultLabel;
  }

  function findCurrentChip(root) {
    var chips = Array.from(root.querySelectorAll('[data-rz-campus-chip]'));
    var currentUrl = getUrlParts(window.location.href);

    return chips.find(function (chip) {
      var href = chip.getAttribute('href');
      var chipUrl = getUrlParts(href);
      if (!href || href === '#') return false;
      if (!chipUrl || !currentUrl) return false;
      return chipUrl.path === currentUrl.path && (!chipUrl.search || chipUrl.search === currentUrl.search);
    });
  }

  function initCampusBar(root) {
    if (root.dataset.rzCampusBarInitialized === 'true') return;
    root.dataset.rzCampusBarInitialized = 'true';

    var toggle = root.querySelector('[data-rz-campus-toggle]');
    var initialOpen = root.getAttribute('data-initial-open') === 'true';
    var currentChip = findCurrentChip(root);

    setSelectedChip(root, currentChip);
    setOpen(root, initialOpen);

    if (toggle) {
      toggle.addEventListener('click', function () {
        setOpen(root, toggle.getAttribute('aria-expanded') !== 'true');
      });
    }

    root.addEventListener('click', function (event) {
      var chip = event.target.closest('[data-rz-campus-chip]');
      if (!chip || !root.contains(chip)) return;

      setSelectedChip(root, chip);

      var href = chip.getAttribute('href');
      if (!href || href === '#') {
        event.preventDefault();
      }
    });
  }

  function initAllCampusBars() {
    document.querySelectorAll('[data-rz-campus-bar]').forEach(initCampusBar);
  }

  function setCampusBarsCollapsed(collapsed) {
    document.querySelectorAll('[data-rz-campus-bar-section]').forEach(function (section) {
      if (collapsed) {
        section.setAttribute('data-rz-campus-bar-collapsed', 'true');
      } else {
        section.removeAttribute('data-rz-campus-bar-collapsed');
      }
    });
  }

  function initCampusBarScrollCollapse() {
    if (!document.querySelector('[data-rz-campus-bar-section]')) return;
    if (window.RzCampusBarScrollCollapseInitialized === true) return;
    window.RzCampusBarScrollCollapseInitialized = true;

    var lastScrollY = scrollY();
    var ticking = false;
    var scrollThreshold = 20;
    var minDeltaDown = 12;
    var minDeltaUp = 8;
    var showLockUntil = 0;

    function updateCollapsed() {
      if (!window.matchMedia || !window.matchMedia('(min-width: 1201px)').matches) {
        setCampusBarsCollapsed(false);
        lastScrollY = scrollY();
        ticking = false;
        return;
      }

      var currentScrollY = scrollY();
      if (currentScrollY <= scrollThreshold) {
        setCampusBarsCollapsed(false);
        lastScrollY = currentScrollY;
        ticking = false;
        return;
      }

      var delta = currentScrollY - lastScrollY;
      lastScrollY = currentScrollY;

      if (delta > minDeltaDown) {
        if (Date.now() >= showLockUntil) setCampusBarsCollapsed(true);
      } else if (delta < -minDeltaUp) {
        setCampusBarsCollapsed(false);
        showLockUntil = Date.now() + 450;
      }

      ticking = false;
    }

    function onScroll() {
      if (ticking) return;
      ticking = true;
      requestAnimationFrame(updateCollapsed);
    }

    window.addEventListener('scroll', onScroll, { passive: true });

    var mql = window.matchMedia && window.matchMedia('(min-width: 1201px)');
    if (mql && mql.addEventListener) {
      mql.addEventListener('change', function () {
        if (!mql.matches) setCampusBarsCollapsed(false);
      });
    }

    updateCollapsed();
  }

  function init() {
    initAllCampusBars();
    initCampusBarScrollCollapse();
  }

  window.RzCampusBarInit = init;

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
